import { MessageService } from 'app/services/messages.service';
import { TrackingConstants } from 'app/shared/services/tracking/tracking-constants.service';
import { SnackBarService } from 'app/services/snackbar.service';
import { Component } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { NavigationBarService } from 'app/header/navigationbar/navigation-bar.service';
import { TrackingService } from 'app/shared/services/tracking/google-analytics-events.service';

@Component({
    moduleId: module.id,
    templateUrl: 'confirm-delete-transaction.component.html',
    styleUrls: ['confirm-delete-transaction.component.css']
})
export class ConfirmDeleteTransactionComponent {
    client: any;

    constructor(
        public dialogRef: MdDialogRef<any>,
        private navigationBarService: NavigationBarService,
        private trackingService: TrackingService,
        private snackBarService: SnackBarService,
    ) {
    }

    delete() {
        this.navigationBarService.deleteTransactionOfClient(this.client.id).subscribe(
            success => {
                this.trackingService
                    .emitEvent(TrackingConstants.TRANSACTIONS, TrackingConstants.TRANSACTION_DELETE, TrackingConstants.SUCCESS, 1);
                this.callSnackBarService(success);
                this.dialogRef.close(success);
            },
            err => {
                this.dialogRef.close(false);
                this.callSnackBarService(err);
                this.trackingService
                    .emitEvent(TrackingConstants.TRANSACTIONS, TrackingConstants.TRANSACTION_DELETE, TrackingConstants.FAILURE, 0);
            }
        );
    }

    callSnackBarService(response: any) {
        this.snackBarService
            .showStatus(response,
            MessageService.TRANSACTION_DELETE_SUCCESS,
            MessageService.TRANSACTION_DELETE_FAILURE);
    }
}



// WEBPACK FOOTER //
// ./src/app/header/navigationbar/delete-client-transaction/confirm-delete-transaction/confirm-delete-transaction.component.ts